import { useAtom } from '@reatom/npm-react'
import { useRef, useState } from 'react'
import styled from 'styled-components'

import { DEMO_MODE, showDebugScreenAtom } from '@root/shared'

import { DevStatusDialog } from './dev-status-dialog'

export const DevStatus = () => {
  const debugRef = useRef({ taps: 0, timeoutId: 0 })
  const [open, setOpen] = useState(false)
  const [_, setShowDebugScreen] = useAtom(showDebugScreenAtom)

  const handleShowDebugScreen = () => {
    debugRef.current.taps += 1
    if (debugRef.current.taps > 10) {
      setShowDebugScreen(true)
    }

    clearTimeout(debugRef.current.timeoutId)
    debugRef.current.timeoutId = window.setTimeout(() => {
      debugRef.current.taps = 0
    }, 300)
  }

  return import.meta.env.DEV ? (
    <DevStatusDialog open={open} onOpenChange={setOpen}>
      <Root type="button" onClick={handleShowDebugScreen}>
        {DEMO_MODE ? <Text>DEMO</Text> : undefined}
      </Root>
    </DevStatusDialog>
  ) : undefined
}

const Root = styled.button`
  all: unset;
  cursor: pointer;
  height: 22px;
  min-width: 48px;
  background: repeating-linear-gradient(
    -45deg,
    var(--yellow-11),
    var(--yellow-11) 5px,
    black 5px,
    black 10px
  );
  display: flex;
  align-items: center;
  justify-content: center;
`

const Text = styled.div`
  padding: 3px;
  background: var(--appearance-1);
  color: var(--yellow-11);
  font-size: 10px;
  line-height: normal;
  font-weight: 700;
  font-family: monospace;
`
